'use client'

import useGallery from '@hooks/useGallery'
import useVideoPlayer from '@hooks/useVideoPlayer'
import IconFilm from '@icon/house/film.svg'
import IconFloorplan from '@icon/house/floorplan.svg'
import IconMap from '@icon/house/map.svg'
import IconPicture from '@icon/house/picture.svg'
import { isOfflineData } from '@utils/house'
import classNames from 'classnames'
import { isFunction, size } from 'lodash-es'
import { useCallback } from 'react'
import { useHouseCoverContext } from '../cover/context'

export default function ImageBar({
  data
}) {

  const {
    imageSize,
    video,
    floorPlanImages,
    imageTagTidy,
    threeD,
    showImageBar,
    images,
    showMap,
    toggleShowMap,
    isEstimate
  } = useHouseCoverContext()

  // 图片是否可以点击
  // const clickable = useMemo(() => isSaleData(data) || isRentData(data), [data])
  const clickable = showImageBar

  const { showGallery } = useGallery()
  const { showVideoPlayer } = useVideoPlayer()

  return showImageBar && (
    <div className='section-wrap -mt-22 relative z-10'>
      <div className='flex shadow-sm bg-white border rounded-sm sm:inline-flex'>
        <Item clickable={clickable} text='Pictures' data={data} num={imageSize} showNum={!isEstimate} active={!showMap} Icon={IconPicture} onClick={showMap ? () => toggleShowMap() : !isEstimate && showGallery({ house: data, images, floorPlanImages, imageTagTidy, index: 0 })}></Item>
        {
          size(floorPlanImages) > 0 && (
            <Item clickable={clickable} text='Floorplan' data={data} num={size(floorPlanImages)} Icon={IconFloorplan} onClick={showGallery({ house: data, images, floorPlanImages, imageTagTidy, index: size(images) })}></Item>
          )
        }
        <Item clickable={clickable} text='Map' data={data} num={data.lat && data.lng ? 1 : 0} showNum={false} active={showMap} Icon={IconMap} onClick={() => toggleShowMap(true)}></Item>
        {
          (video || threeD) && (
            <Item clickable={clickable} text='Video & 3D tour' data={data} num={1} Icon={IconFilm} onClick={video ? showVideoPlayer({ url: video }) : showVideoPlayer({ url: threeD })}></Item>
          )
        }
      </div>
    </div>
  )
}

function Item({
  Icon,
  text,
  num,
  showNum = true,
  active = false,
  onClick,
  clickable,
  data
}) {

  const has = num > 0
  const clickHandle = useCallback(event => {
    if (has && clickable && isFunction(onClick)) onClick(event)
  }, [onClick, has, clickable])
  // (has || (data.houseId && !isOfflineData(data))) &&
  return (
    <div
      className={classNames(
        'flex-1 h-40 flex items-center justify-center px-8 relative border-l first:border-l-0 border-b',
        { 'cursor-pointer': has && clickable },
        active ? 'border-b-primary' : 'border-b-transparent'
      )}
      onClick={clickHandle}
    >
      <Icon width={16} height={16} className={classNames('hidden sm:block', has ? 'fill-primary' : 'fill-neutral-3')}></Icon>
      <span className={classNames('ml-6 text-sm whitespace-nowrap', has ? 'text-primary' : 'text-neutral-3')}>{text}</span>
      {showNum && has && <span className='flex-shrink-0 absolute left-8 top-0 -translate-y-1/2 bg-secondary text-white w-20 h-20 flex items-center justify-center text-xs rounded-half'>{num}</span>}
    </div>
  )
}